import React from "react";
import { motion } from "framer-motion";
import PageHero from "@/components/PageHero";
import FinalCTA from "@/components/FinalCTA";
import { Reveal } from "@/components/Reveal";
import { Flower2 } from "lucide-react";

/** Shared layout for the three lotus-symbolism pages (Udsatte, ADHD, Autisme) */
const SymbolPage = ({ data, image }) => (
  <>
    <PageHero eyebrow="Lotus" title={data.hero} intro={data.intro} image={image} />

    <section className="max-w-4xl mx-auto px-5 sm:px-8 py-16 lg:py-24">
      {data.lead && (
        <Reveal>
          <p className="font-display text-2xl sm:text-3xl leading-snug text-[#2D5A3F] mb-14">{data.lead}</p>
        </Reveal>
      )}

      <Reveal>
        <h2 className="font-display text-3xl sm:text-4xl text-[#1A2E24] mb-10">{data.pointsTitle}</h2>
      </Reveal>

      <div className="grid sm:grid-cols-2 gap-6">
        {data.points.map((p, i) => (
          <motion.div
            key={p.h}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i % 2) * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="group rounded-2xl bg-white border border-black/5 p-7 hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
            data-testid={`symbol-point-${i}`}
          >
            <span className="flex items-center justify-center h-11 w-11 rounded-full bg-[#EAE5D9] text-[#2D5A3F] mb-5">
              <Flower2 className="h-5 w-5" strokeWidth={1.5} />
            </span>
            <h3 className="font-display text-2xl text-[#1A2E24] mb-2">{p.h}</h3>
            <p className="text-[#3B5245] leading-relaxed">{p.t}</p>
          </motion.div>
        ))}
      </div>

      {data.outro && (
        <Reveal delay={0.1}>
          <div className="mt-14 rounded-2xl bg-[#EAE5D9] p-8 sm:p-10 border-l-4 border-[#C47C5D]">
            <p className="text-lg text-[#3B5245] leading-relaxed">{data.outro}</p>
          </div>
        </Reveal>
      )}
    </section>

    <FinalCTA />
  </>
);

export default SymbolPage;
